import React from 'react';
import {withRouter} from 'react-router-dom';
import {Col, Container, Row} from 'react-bootstrap';
import {Button, Form, Input, notification, Popconfirm, Select, Tabs} from 'antd';
import HelperGeneral from '../../../helpers/HelperGeneral';
import moment from 'moment';
import Api from '../../../services/Api';
import {setGlobalSpinner} from '../../../services/redux/actions/GeneralAction';
import UserInfo from '../../auth/UserInfo';
import {faArrowLeft, faArrowRight, faTruck} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Lottie from "react-lottie";
import animation from '../../../assets/coupon_animation.json';
import Order from './myAccount/Order';
import Profile from "../Profile";
import ContactPreferences from "../ContactPreferences";

class MyAccount extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            active_tab: this.props?.match?.params?.tab_key,
            product_data: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: true,
            transactionType: -1,
            transactionStartDate: '',
            transactionEndDate: '',
            getBasketHeaderAll: {}
        }

        this.passwordFormRef = React.createRef();

        this.product_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'date',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.transactionDate).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'İşlem Tipi',
                dataIndex: 'product_name',
                render: (name, record) => record?.transactionType === 1 ? 'Kullanım' : 'Kazanım',
                width: 200,
            },
            {
                title: 'Açıklama',
                dataIndex: 'barcode',
                render: (name, record) => (
                    <>
                        {record?.name}
                        <div className={'alt_description'}>{record?.account?.name}</div>
                    </>
                ),
            },
            {
                title: 'Puan',
                dataIndex: 'point',
                width: 150,
                align: 'center',
                render: (name, record) => {
                    return (
                        <div className={record?.transactionType === 1 ? 'minus' : ''}>
                            {record?.transactionType === 2 ? '+' : '-'}{record?.earnedPoint} Puan
                        </div>
                    )
                },
            },
            {
                title: '',
                dataIndex: 'operation',
                width: 130,
                render: (text, record) => (
                    <Popconfirm
                        title="Emin misiniz?"
                        overlayClassName={'border-radius-8'}
                        onConfirm={() => this.transactionRemove(record)}
                    >
                        <Button className={'cancel-button'}>İşlemi İptal Et</Button>
                    </Popconfirm>
                ),
            },
        ]
    }

    componentDidMount() {
        // const {pagination} = this.state;
        //this.getTransactions({pagination});
        //this.getBasketHeaderAll();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const tab_key = this.props?.match?.params?.tab_key;
        if (this.state.active_tab !== tab_key) {
            this.setState({
                active_tab: tab_key
            });
            //this.getBasketHeaderAll();
        }
    }

    // getTransactions = (params = {}) => {
    //     this.setState({loading: true}, () => {
    //         Api.getTransactions(
    //             this.state.transactionType,
    //             params.pagination.current,
    //             params.pagination.pageSize,
    //             this.state.transactionStartDate,
    //             this.state.transactionEndDate,
    //         ).then(response => {
    //             const result = response.data.result
    //             this.setState({
    //                 loading: false,
    //                 product_data: result.data,
    //                 pagination: {
    //                     ...params.pagination,
    //                     total: result.page.totalCount,
    //                 },
    //             })
    //         }).catch((e) => {
    //             this.setState({
    //                 loading: false,
    //             }, () => HelperGeneral.alert(e))
    //         })
    //     })
    // }

    // transactionRemove = (record) => {
    //     this.setState({
    //         loading: true,
    //     }, () => {
    //         Api.transactionRemove(record?.transactionId).then(() => {
    //             this.setState({loading: false}, () => {
    //                 const {pagination} = this.state
    //                 this.getTransactions({pagination})
    //                 notification['success']({
    //                     message: 'Başarılı!',
    //                     description:
    //                         'İşlem iptali başarıyla gerçekleşti',
    //                 })
    //             })
    //         }).catch((e) => {
    //             this.setState({loading: false}, () => {
    //                 HelperGeneral.alert(e)
    //             })
    //         })
    //     })
    // }

    updatePassword = (e) => {
        setGlobalSpinner(true);

        let data = {
            'old_password': e?.old_password,
            'new_password': e?.new_password,
            'new_password_confirm': e?.new_password_confirm
        };

        Api.changePassword(data).then(r => {
            setGlobalSpinner(false);
            this.passwordFormRef.current.resetFields();
            HelperGeneral.alert('Şifreniz değiştirildi.', 'success');
        }).catch((e) => {
            setGlobalSpinner(false)
            const errorMessage = e?.data?.errors?.old_password?.[0] ?? null;
            HelperGeneral.alert(errorMessage);
        })
    }

    getBasketHeaderAll() {
        const user = UserInfo.info();
        const userId = user.id;

        this.setState({
            loading: true,
        }, () => {
            Api.getBasketHeaderAll(userId).then((e) => {
                this.setState({loading: false}, () => {
                    this.setState({getBasketHeaderAll: e.data?.result});
                });
            }).catch((e) => {
                this.setState({loading: false}, () => {
                    HelperGeneral.alert(e);
                })
            })
        })

        //test
    }

    render() {
        const {active_tab, product_data, pagination, loading, transactionType, getBasketHeaderAll,} = this.state;
        const user = UserInfo.info();
        user['birthDate'] = moment(user.birthDate).format('DD/MM/YYYY');

        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animation,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
            },
        };

        const lottieLoading = () => (
            <div>
                <Lottie options={defaultOptions} style={{height: 80}}/>
            </div>
        );

        return (
            <div className={'my-account pb-0 pb-sm-5 min-height-container'}>
                <Container>
                    <Row>
                        <Col xs={12} className={'mt-2 mt-sm-4'}>
                            <div className={'username'}>{UserInfo.fullUserName()}</div>
                            <div className={'tab-area'}>
                                <Tabs
                                    activeKey={active_tab}
                                    onChange={(active_tab) => HelperGeneral.pageChange(this, '/my-account/' + active_tab)}
                                >
                                    <Tabs.TabPane tab={'Hesap bilgileri'} key={'bilgilerim'}>
                                        <Profile/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab={'Şifre değişikliği'} key={'sifre'}>
                                        <div className={'box'}>
                                            <h2>Şifre Değişikliği</h2>
                                            <div className={'description margin'}>
                                                Şifreniz en az 8 karakter olmalı ve en az bir harf ile bir rakam içermelidir.
                                            </div>
                                            <Form
                                                ref={this.passwordFormRef}
                                                layout={'vertical'}
                                                initialValues={{layout: ''}}
                                                onFinish={(e) => this.updatePassword(e)}
                                            >
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Mevcut şifreniz'}
                                                            name="old_password"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Mevcut şifrenizi giriniz',
                                                                    min: 8,
                                                                },
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Yeni şifreniz'}
                                                            name="new_password"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Yeni şifrenizi en az 8 haneli olacak şekilde giriniz',
                                                                    min: 8,
                                                                },
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Yeni şifreniz (Tekrar)'}
                                                            name={"new_password_confirm"}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Yeni şifre tekrarı zorunlu bir alandır',
                                                                    min: 8,
                                                                },
                                                                ({getFieldValue}) => ({
                                                                    validator(_, value) {
                                                                        if (!value || getFieldValue('new_password') === value) {
                                                                            return Promise.resolve()
                                                                        }
                                                                        return Promise.reject(new Error('Yeni şifre tekrarı aynı değil'))
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={'auto'} className={'mx-auto'}>
                                                        <Form.Item className={'m-0'}>
                                                            <Button type={"primary"} htmlType={'submit'}>Güncelle</Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab={'İletişim Tercihlerim'} key={'iletisim-tercihlerim'}>
                                        <ContactPreferences/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab={'Siparişlerim'} key={'siparislerim'}>
                                        <Order/>
                                    </Tabs.TabPane>
                                    {/*
                                         <Tabs.TabPane tab={'Doldur Kazan'}
                                                  key={'earn-points'}>

                                        <div className={'product-history mb-0 coupon-box'}>
                                            <Form
                                                ref={this.form}
                                                layout={'vertical'}

                                            >
                                                <div className={'row'}>
                                                    <div
                                                        className={'col-lg-6 col-12 text-lg-start text-center'}>
                                                        <h3 className={'text-lg-start text-center'}>Arkadaşını Davet Et</h3>
                                                        <p className={'text-lg-start text-center'}><br/></p>

                                                        <Form.Item
                                                            name="email"
                                                            rules={[
                                                                {
                                                                    required:true,
                                                                    type: 'email',
                                                                    message:'E-posta adresi gerekli bir alan'
                                                                },
                                                            ]}
                                                        >
                                                            <Input  placeholder="E-posta Adresiniz" />
                                                        </Form.Item>
                                                    </div>
                                                    <div className={'col-lg-6 col-12 '}>
                                                        <div className={'row h-100'}>
                                                            <div className={'col-lg-4 col-12 '}>
                                                                <div className={'row h-100 position-relative'}>

                                                                    <div
                                                                        className={'col-12 d-flex align-items-end justify-content-center price text-black'}>
                                                                        {lottieLoading()}
                                                                    </div>
                                                                    <div
                                                                        className={'col-12 d-flex align-items-end justify-content-start title mb-lg-0 mb-3 '}>
                                                                        <Form.Item className={'w-100'}>
                                                                            <Button
                                                                                htmlType={'submit'}
                                                                                className={'coupon-button  w-100'}>Davet Et</Button>
                                                                        </Form.Item>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={'col-lg-8 col-12 d-flex align-content-center justify-content-center '}>
                                                                <div
                                                                    className={'box right-box w-100 h-100 m-0 p-0'}>
                                                                    <p>Bilgilendirme </p>
                                                                    <p>Arkadaşınızı e-posta adresi ile davet edin.Üye olan her arkadaşınız için puan kazanın ve harcayın.</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>

                                        </div>


                                    </Tabs.TabPane>
                                    */}
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default withRouter(MyAccount);
